import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { getNotificationDelivery, updateNotificationDelivery } from './notification-delivery.api';
import type { NotificationDeliveryOption } from './notification-delivery.types';

const DELIVERY_KEY = ['notification-delivery'];

export const useNotificationDeliveryQuery = () =>
  useQuery({
    queryKey: DELIVERY_KEY,
    queryFn: () => getNotificationDelivery(),
    // The option may not exist yet for a user (404) — don't retry, fall back in the UI.
    retry: false,
  });

export const useUpdateNotificationDeliveryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (deliveryOption: NotificationDeliveryOption) =>
      updateNotificationDelivery(deliveryOption),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: DELIVERY_KEY });
    },
  });
};
